// extracted by mini-css-extract-plugin
module.exports = {"container":"pages-season-container","title":"pages-season-title"};